var map = {
	"./P2-B1.svg": "3bf7",
	"./P2-B2.svg": "82ef",
	"./P2-B3.svg": "1b3c",
	"./P2-B4.svg": "cdb5",
	"./P2-B5.svg": "f8d6",
	"./P2-B6.svg": "050c",
	"./P2-B7.svg": "3302",
	"./P2-B8.svg": "19f7",
	"./P2-B9.svg": "cc1b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a7e";